import "./Contact.module.css";
import Zahlavi from "@/reusable_sections/Header";
import JsmeVamKDispozici from "./sections/JsmeVamKDispozici";
import KdeNasNajdete from "./sections/KdeNasNajdete";
import B2BClientFaq from "./sections/B2BClientFaq";
import Zapati from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Zahlavi />
      <JsmeVamKDispozici />
      <KdeNasNajdete />
      <B2BClientFaq />
      <Zapati />
    </div>;
}